import { render, staticRenderFns } from "./ESGTrainings.vue?vue&type=template&id=c3ffd674&scoped=true"
import script from "./ESGTrainings.vue?vue&type=script&lang=js"
export * from "./ESGTrainings.vue?vue&type=script&lang=js"
import style0 from "./ESGTrainings.vue?vue&type=style&index=0&id=c3ffd674&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c3ffd674",
  null
  
)

export default component.exports